import React, { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "../../styles/admanager/UserAdManagement.module.scss";
import { Switch, Route } from "react-router-dom";
import UserAdSettings from "./UserAdSettings.jsx";
import UserAdEarnings from "./UserAdEarnings.jsx";
import UserAdGames from "./UserAdGames.jsx";
import { AD_MANAGER_SUBROUTES } from "../../constants/subroutes";
import TabNavigation from "../helpers/TabNavigation";
import { RouteContext } from "../UserAccount";
import selectCurrentState from "../../selectors/selectCurrentState";
import currentUserInfo from "../../selectors/currentUserInfo";
import { fetchAccountData } from "../../actions/account.ts";

export default function UserAdManagement(props) {
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserInfo);
  const { activeSubtab, setSubTab } = useContext(RouteContext);
  const { workState } = useSelector(selectCurrentState);

  async function fetchData() {
    await dispatch(fetchAccountData());
  }

  useEffect(() => {
    if (currentUser) {
      fetchData();
    }
    //eslint-disable-next-line
  }, [currentUser]);

  const checkSetUpStatus = () => {
    return (
      <TabNavigation
        routes={AD_MANAGER_SUBROUTES}
        activeSubtab={activeSubtab}
        setSubTab={setSubTab}
      >
        <Switch>
          <Route path="/account/ads/settings" component={UserAdSettings} />
          <Route
            props={props}
            path="/account/ads/earnings"
            component={UserAdEarnings}
          />
          <Route path="/account/ads/games" component={UserAdGames} />
        </Switch>
      </TabNavigation>
    );
  };

  return (
    <div className={styles.userSupportWrapper}>
      <div>{workState.GAMState}</div>
      {checkSetUpStatus()}
    </div>
  );
}
